<template>
  <b-modal
    :visible="shown"
    size="lg"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @hide="handleClose"
    hide-footer>

    <div slot="modal-title">
      <h4 class="m-0">Speak with our support team</h4>
      <div class="title-description">
        We’d love to know how we can best serve you
      </div>
    </div>

    <!--<b-row class="my-1">
      <b-col md="3">
        <label for="subject">Subject:</label>
      </b-col>
      <b-col md="9">
        <b-form-input
            id="subject"
            size="md"
            v-model="subject"
            type="text"
            placeholder="Subject"
            :state="!subject ? false : null"
            required />
      </b-col>
    </b-row>-->
    <b-row class="my-1">
      <b-col md="3">
        <label for="message">Your Message:</label>
      </b-col>
      <b-col md="9">
        <b-form-textarea
            id="message"
            size="md"
            rows="3"
            v-model="message"
            placeholder="Message" />
      </b-col>
    </b-row>
    <b-button
      variant="primary"
      class="px-5"
      @click="sendMessage"
      :disabled="isSending">
      <i class="fa fa-spin fa-spinner mr-2" v-if="isSending"/>
      <span>Send Message&nbsp;</span>
    </b-button>

  </b-modal>
</template>

<script>
  import axios from "axios";
  import { fullURL } from "../utils";

  export default {
    name: 'ContactSupportModal',
    components: {},
    props: {
      shown: Boolean
    },
    
    data() {
      const user = this.$store.state.general.user;
      return {
        user: user,
        isSending: false,
        subject: null,
        message: null
      };
    },

    methods: {
      handleClose() {
        console.log("Support: ", this.subject)
        this.$emit('close');
      },

      sendMessage() {
        this.isSending = true;
        var data = {"subject": "NEW SUPPORT MESSAGE FROM SUPERSCORE PLATFORM"}; // {"subject": this.subject};
        if (!!this.message) {
          data["message"] = this.message;
        }
        console.log("Support Message 1: ", data);
        axios.post(fullURL(`/contact-support`), data).then(({data}) => {
            console.log("Support Message: ", data);
            this.isSending = false;
            this.$emit('success');
            this.handleClose();
          }
        );
      }
    },

    computed: {
    }
  };
</script>

<style scoped>
  .title-description {
    font-weight: normal;
    font-size: .8em;
  }
</style>
